<template lang="pug">
.testmail-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="send" @cancel="cancel")
    div(slot="modal-title")
      span 登録確認のメール送信

    .testmail-modal-body
      p(v-if="targetType == 1")
        span 登録後にこの登録確認メールを送信し、
        span.font-strong-color ご家族が受信できているかをお電話等でご確認ください。
        br
        span タイトル・本文にサンプルが入っていますので、必要に応じて修正して送信ください。
        br
        span 送信履歴はメッセージ送信画面の履歴（家族）でご確認いただけます。
      p(v-if="targetType == 2")
        span 登録後にこの登録確認メールを送信し、
        span.font-strong-color 施設関係者が受信できているかをお電話等でご確認ください。
        br
        span タイトル・本文にサンプルが入っていますので、必要に応じて修正して送信ください。
        br
        span 送信履歴はメッセージ送信画面の履歴（施設関係者）でご確認いただけます。
      .register-body
        FormLabel(key-name="宛先" :value="_target")
        
        FormInput(
          key-name="タイトル"
          required
          name="subject"
          v-model="_subject"
          type="text"
          placeholder="タイトル"
          :maxlength="100"
          :validation-rules="{ required: true, max: 100 }"
          :styles="{ width: '340px' }")
          
        FormTextarea(
          key-name="本文"
          required
          name="text"
          v-model="_text"
          placeholder="本文"
          :validation-rules="{ required: true, max: 1000 }"
          :maxlength="1000"
          :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }")

    .testmail-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }" style="width:100%;")
      ValidationAlert(v-model="_showValidationAlert")
      .buttons.d-flex.justify-content-end
        button.btn.modal-ok-btn(type="button" @click="ok()") 送信
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormLabel from "@/pc/components/forms/FormLabel.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";

/**
 * メッセージ送信確認モーダル
 */
@Component({
  components: {
    ValidationAlert,
    FormLabel,
    FormInput,
    FormTextarea
  }
})
export default class TestMailModal extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  @Prop({
    default: () => {
      return "";
    }
  })
  target!: string;

  @Prop()
  targetType!: TestMailTargetType;

  @Prop({
    default: () => {
      return "";
    }
  })
  subject!: string;

  @Prop({
    default: () => {
      return "";
    }
  })
  text!: string;

  @Prop()
  showValidationAlert!: boolean;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _target(): string {
    return this.target;
  }

  get _subject(): string {
    return this.subject;
  }

  set _subject(newValue: string) {
    this.$emit("update:subject", newValue);
    return;
  }

  get _text(): string {
    return this.text;
  }

  set _text(newValue: string) {
    this.$emit("update:text", newValue);
    return;
  }

  get _showValidationAlert(): boolean {
    return this.showValidationAlert;
  }

  set _showValidationAlert(newValue: boolean) {
    this.$emit("update:showValidationAlert", newValue);
    return;
  }

  /**
   * ### 送信ボタン押下処理
   *
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  public send(modalEvent: any): void {
    this.$emit("update:showValidationAlert", false);
    modalEvent.preventDefault();
    this.$emit("sendMail");
    return;
  }

  public cancel(): void {
    this.$emit("update:showValidationAlert", false);
    return;
  }
}

export enum TestMailTargetType {
  /** 種別無し */
  NONE = 0,
  /** 家族ユーザー */
  FAMILY = 1,
  /** 施設関係者 */
  OTHER_USER_GROUP_MEMBER = 2
}
</script>
